import { render, staticRenderFns } from "./td-Key1.vue?vue&type=template&id=d93b97b2&scoped=true&"
import script from "./td-Key1.vue?vue&type=script&lang=js&"
export * from "./td-Key1.vue?vue&type=script&lang=js&"
import style0 from "./td-Key1.vue?vue&type=style&index=0&id=d93b97b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93b97b2",
  null
  
)

export default component.exports